import "core-js/modules/es.array.push.js";
import { mapState } from 'vuex';
import i18n from '@/lang/index.js';
import QRCode from 'qrcode';
import { handleLocalStorage, userBgColor } from '@/assets/js/utils.js';
export default {
  props: {
    partyCode: {
      type: String,
      default: ''
    },
    inviteInfo: {
      type: Object,
      default: function () {
        return {};
      }
    }
  },
  data() {
    var _JSON$parse;
    return {
      qCode: '',
      qrCodeUrl: '',
      searchName: '',
      passCodeVal: '',
      selectModule: '',
      willInviteList: [],
      hadInviteList: [],
      showErrorEmailText: false,
      joinModel: [{
        value: 0,
        label: 'Anyone with the link can join'
      }, {
        value: 1,
        label: 'Only users added to the list can join'
      }, {
        value: 3,
        label: 'Anyone with passcode can join'
      }],
      editPass: false,
      env: handleLocalStorage('get', 'partylineConfig') ? (_JSON$parse = JSON.parse(handleLocalStorage('get', 'partylineConfig'))) === null || _JSON$parse === void 0 ? void 0 : _JSON$parse.apiEnv : '',
      inputTimer: 0
    };
  },
  computed: {
    ...mapState({
      State: state => state
    }),
    urlAddress() {
      const domain = window.location.host;
      this.showIt = window.location.href.includes('control') || this.$route.name === 'party';
      return 'https://' + domain + '/partyline?join_id=' + this.partyCode + `${this.env ? '&env=' + this.env : ''}`;
    }
  },
  watch: {
    'inviteInfo.show': {
      handler(newVal) {
        if (newVal) {
          // 弹窗打开清空状态
          this.editPass = false;
          this.showErrorPassCode = false;
          this.createQrCode();
        }
      }
    }
  },
  methods: {
    createQrCode() {
      this.qCode = QRCode.toDataURL(this.urlAddress).then(url => {
        this.qrCodeUrl = url;
      });
    },
    checkInputText(val) {
      if (new Date().getTime() - this.inputTimer < 1500) return;
      this.inputTimer = new Date().getTime();
      var regEmail = /^([a-zA-Z0-9_\-\.])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/;
      if (val && !regEmail.test(val)) {
        this.showErrorEmailText = true;
        this.$refs.emailInput.$el.children[0].focus();
      } else {
        this.showErrorEmailText = false;
      }
    },
    setJoinWay() {
      if (!this.isEmail(this.searchName)) return;
      if (!this.passCodeVal && this.selectModule === 3 && this.passCodeVal.length != 6) {
        this.$message.warning(this.$t('invite.plsInpPasscode'));
        return;
      }
      const inviteList = [];
      this.willInviteList.forEach(user => {
        const obj = {};
        obj.memberEmail = user.name;
        obj.partyCode = this.partyCode;
        inviteList.push(obj);
      });
      // 只添加一个走这里
      if (!this.willInviteList.length && this.searchName) {
        inviteList.push({
          memberEmail: this.searchName,
          partyCode: this.partyCode
        });
      }
      const linkUrl = 'https://' + window.location.host + '/partyline?join_id=' + this.partyCode + `${this.env ? '&env=' + this.env : ''}`;
      const params = {
        inviteMode: this.selectModule,
        partyCode: this.partyCode,
        emailNotification: 1,
        linkUrl: linkUrl,
        partyInviteMemberList: !this.selectModule ? [] : inviteList,
        invitePassCode: this.passCodeVal ? this.passCodeVal : ''
      };
      this.axios.post('/partyline-backend/partyExtendInfo', params, {
        errorTip: false
      }).then(res => {
        const {
          errorCode,
          errorInfo
        } = res.data;
        if (errorCode === '0x0') {
          this.searchName = '';
          if (!params.inviteMode) this.hadInviteList = [];
          this.$message.success(this.$t('invite.inviteSetSuccess'));
        } else if (errorCode === '9000002') {
          this.$message.warning(this.$t('personalInfo.forbidSetting'));
        } else if (errorCode === '80520105') {
          this.$message.error(params.partyInviteMemberList[0].memberEmail + this.$t('invite.alreadyInvited'));
        } else {
          this.$message.error(errorInfo);
        }
      });
    },
    isEmail(val) {
      var regEmail = /^([a-zA-Z0-9_\-\.])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/;
      if (val && !regEmail.test(val)) {
        this.showErrorEmailText = true;
        this.$refs.emailInput.$el.children[0].focus();
        return false;
      }
      return true;
    },
    async getHadInviteUser(showList) {
      // 清空之前的状态
      this.searchName = '';
      this.showErrorEmailText = false;
      this.willInviteList = [];
      await this.axios.get(`/partyline-backend/partyExtendInfo/${this.partyCode}`).then(res => {
        const {
          errorCode,
          result
        } = res.data;
        if (errorCode === '0x0') {
          const array = [];
          result.emailList.forEach(user => {
            const obj = {};
            obj.name = user;
            obj.color = this.hadInviteUserColor[user.length % 4] || 'green';
            array.push(obj);
          });
          this.hadInviteList = array;
          this.passCodeVal = result.invitePassCode;
          // 切换模式的时候不需要更改值
          if (!showList) {
            this.selectModule = result.inviteMode;
          }
        }
      });
    },
    async showHadInvite(model) {
      // 清空模式三passcode
      this.passCodeVal = '';
      this.inviteInfo.hideSave = true;
      if (model === 1) {
        await this.getHadInviteUser('showList');
      }
      if (model === 3) {
        await this.getHadInviteUser('showList');
        this.passCodeVal = this.createRandomPassCode();
      }
      this.setJoinWay();
    },
    createRandomPassCode() {
      let code = '';
      for (var i = 0; i < 6; i++) {
        const type = this.createRandom(1, 3);
        switch (type) {
          case 1:
            code += String.fromCharCode(this.createRandom(48, 57));
            break;
          case 2:
            code += String.fromCharCode(this.createRandom(65, 90));
            break;
          case 3:
            code += String.fromCharCode(this.createRandom(97, 122));
            break;
        }
      }
      return code;
    },
    createRandom(min, max) {
      return Math.round(Math.random() * (max - min) + min);
    },
    addInviteList(email) {
      if (this.searchName === this.State.loginInfo.email) {
        this.$message.warning(this.$t('personalInfo.forbidSetting'));
        return;
      }
      if (email && this.searchName && this.isEmail(this.searchName) && !this.isHadInvitedPass(this.searchName)) {
        const obj = {};
        obj.name = this.searchName;
        obj.color = 'gray';
        this.willInviteList.push(obj);
      }
      this.willInviteList = [...new Set(this.willInviteList)];
      // 转移save逻辑到add(邀请email)
      this.setJoinWay();
      this.inviteInfo.show = false;
    },
    // 判断是否已经存在于列表中(邀请passcode)
    isHadInvitedPass(email) {
      let flag = false;
      this.willInviteList.forEach(item => {
        if (item.name == email) {
          flag = true;
        }
      });
      this.hadInviteList.forEach(info => {
        if (info.name == email && info.status != 2) {
          flag = true;
        }
      });
      if (flag) {
        this.$message.warning(this.$t('personalInfo.hadInvited'));
      }
      return flag;
    },
    removeInvite(index) {
      this.willInviteList.splice(index, 1);
    },
    deleteInvite(email) {
      const params = {
        emailList: [email],
        partyCode: this.partyCode
      };
      this.axios.delete('/partyline-backend/partyExtendInfo/emails', {
        data: params
      }).then(res => {
        const {
          errorCode
        } = res.data;
        if (errorCode === '0x0') {
          this.$message.success(this.$t('invite.inviteDeleteSuccess'));
          this.getHadInviteUser('showList');
        }
      });
    },
    judgePassCode(passCode) {
      this.editPass = true;
      this.passCodeVal = passCode.replace(/[^\w\.\/]/ig, '');
      if (!this.passCodeVal || this.passCodeVal.length != 6) {
        this.showErrorPassCode = true;
      } else {
        this.showErrorPassCode = false;
      }
    },
    modifyPassWord(type) {
      if (!this.passCodeVal) {
        this.$message.warning(this.$t('invite.plsInpPasscode'));
        return;
      }
      if (this.passCodeVal.length != 6) {
        this.$message.warning(this.$t('invite.wrongPasscodeFormat'));
        return;
      }
      const params = {
        partyCode: this.partyCode,
        invitePassCode: this.passCodeVal
      };
      this.axios.post('/partyline-backend/partyExtendInfo', params).then(res => {
        const {
          errorCode
        } = res.data;
        if (errorCode === '0x0') {
          this.inviteInfo.show = false;
          if (type === 'byEnter') this.editPass = false;
          this.$message.success(this.$t('invite.inviteSetCopySuccess'));
        }
      });
    },
    returnColor(info) {
      const {
        status
      } = info;
      if (status === 0 || status === 2) {
        return 'gray';
      } else if (status === 1) {
        return userBgColor(info.collaborateEmail);
      }
    },
    onCopy(item) {
      this.$message({
        message: this.$t('copy.onCopy'),
        type: 'success'
      });
    },
    onError() {
      this.$message({
        message: this.$t('copy.onError'),
        type: 'error'
      });
    }
  },
  filters: {
    showJoinModel(value) {
      if (value === 0) {
        return i18n.t('invite.anyoneJoin');
      } else if (value === 1) {
        return i18n.t('invite.onlyUserJoin');
      } else if (value === 3) {
        return i18n.t('invite.onlyByPasscode');
      } else {
        return val;
      }
    }
  }
};